export default __webpack_public_path__ + "static/media/xls.23a0be77.svg";